import '../css/flipbook_embed_bookshelf_page.css';
import 'jquery-migrate';
import $ from 'jquery';
import getParentOrigin from './flipbook_parent_origin';

window.jQuery = window.$j = window.$ = $; // Needed for bootstrap-tooltip, thickbox
require('../js/static/bootstrap-tooltip'); // Use require here to ensure bootsrap loads after jQuery setup

/**
 * We have to re-add the deprecated browser object to jQuery in order for
 * thickbox to work. Its okay if its empty;
 */
$.browser = {};

function init() {
  // Uses in a mixed content situation, letting parent know it's loaded
  if (window.postMessage) {
    window.parent.postMessage('loaded', getParentOrigin());
  }

  $(document).ready(function () {
    $('[data-toggle=tooltip]').tooltip();
  });
}

export { init };
